import {
    apiRequest,
    ListMutasiBaru as List,
    ListDetailMutasiBaru as ListDetail,
    CreateMutasiBaru,
    ListPegawai,
    ListUnitKerja,
    ListJabatan,
    Inactive,
    InactiveDetail,
    Detail,
    DetailMutasi,
    masterRegion,
    UpdateTMTStart,
    UpdateTMTEnd,
    UploadDecree,
    UpdateSuratKeputusan,
    UpdateSPKeluarga,
    UpdateSpp,
    UpdateSpmt,
    UpdateSpmj,
    coupleList,
    childList,
    cekmandatory,
    fetchExport
} from "../../../../../services/adapters/kepegawaian/mutasiPegawaiService"

class IndexRepository {

    fetchList = async (query, cancelToken) => {
        return await apiRequest("get", List, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListDetail = async (query, cancelToken) => {
        return await apiRequest("get", ListDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchCreate = async (query, cancelToken) => {
        return await apiRequest("post", CreateMutasiBaru, {
            cancelToken: cancelToken,
            body: query
        }, true)
    }

    fetchListPegawai = async (query, cancelToken) => {
        return await apiRequest("get", ListPegawai, {
            cancelToken: cancelToken,
            params: query,
        }, true)
    }

    fetchListUnitKerja = async (query, cancelToken) => {
        return await apiRequest("get", ListUnitKerja, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListJabatan = async (query, cancelToken) => {
        return await apiRequest("get", ListJabatan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", Inactive, {
            body: query,
        }, true)
    }

    fetchInactiveDetail = async (query) => {
        return await apiRequest("post", InactiveDetail, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", Detail, {
            params: query,
        })
    }

    fetchDetailMutasi = async (query) => {
        return await apiRequest("get", DetailMutasi, {
            params: query,
        })
    }

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }

    fetchTMTEnd = async (query, cancelToken) => {
        return await apiRequest("post", UpdateTMTEnd, {
            body: query
        }, true)
    }
    fetchTMTStart = async (query, cancelToken) => {
        return await apiRequest("post", UpdateTMTStart, {
            body: query
        }, true)
    }

    ftechUploadDecree = async (query, cancelToken) => {
        return await apiRequest("post", UploadDecree, {
            body: query
        }, true)
    }
    fetchUpdateSuratKeputusan = async (query, cancelToken) => {
        return await apiRequest("post", UpdateSuratKeputusan, {
            body: query
        }, true)
    }
    fetchUpdateSPKeluarga = async (query, cancelToken) => {
        return await apiRequest("post", UpdateSPKeluarga, {
            body: query
        }, true)
    }
    fetchUpdateSpp = async (query, cancelToken) => {
        return await apiRequest("post", UpdateSpp, {
            body: query
        }, true)
    }
    fetchUpdateSpmj = async (query, cancelToken) => {
        return await apiRequest("post", UpdateSpmj, {
            body: query
        }, true)
    }
    fetchUpdateSpmt = async (query, cancelToken) => {
        return await apiRequest("post", UpdateSpmt, {
            body: query
        }, true)
    }
    fetchCouple = async (query, cancelToken) => {
        return await apiRequest("get", coupleList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }    
    fetchChild = async (query, cancelToken) => {
        return await apiRequest("get", childList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchcekMandatory = async (query, cancelToken) => {
        return await apiRequest("get", cekmandatory, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchExport = async (query, cancelToken) => {
        return await apiRequest("get", fetchExport, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
}

export default IndexRepository;